// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inputGroup input.form-control,.inputGroup select.custom-select {\n  \n  background-color: #f5f5f5;\n  border: 2px solid #e5e5e5;\n  color: #686666;\n  font-size: 14px;\n}\n\n", ""]);
// Exports
module.exports = exports;
